module.exports = {
    "collectionLabel": `Suggestions`
};


//# sourceMappingURL=fr-FR.main.js.map
